export default __webpack_public_path__ + "static/media/mons10.6e8502bc.jpg";